// @flow

import * as React from 'react';

import type { ProductId } from '@gandi/cart';
import { useTranslator } from '@gandi/translate';
import { Base, Placeholder, Text } from '@gandi/ui';
import {
  SegmentedControl,
  SegmentedControlItem,
} from '@gandi/ui/segmentedcontrol';

import type { GandiFormSelectOption } from 'src/Domain/types';

import styles from './PlanToggleGroupRow.scss';

type Props = {
  onChange: (evt: SyntheticInputEvent<>) => mixed,
  options?: Array<GandiFormSelectOption<number>>,
  value: number,
  /** productId is used to generate a unique field id */
  productId: ProductId,
  title?: string,
};

export default function PlanToggleGroupRow({
  onChange,
  options = [],
  value,
  productId,
  title,
}: Props): React.MixedElement {
  const { __ } = useTranslator();
  const inputId = `plan-${productId}`;

  return (
    <Base flex flexJustifyBetween flexAlignItemsCenter className={styles.root}>
      <Text weight="semibold" size="base">
        {title || __('Your offer')}
      </Text>
      {options.length > 1 && (
        <SegmentedControl
          size="s"
          name={inputId}
          value={`${value}`}
          onChange={onChange}
        >
          {options.map(opt => (
            <SegmentedControlItem
              className={styles.label}
              value={`${opt.value}`}
              key={`${productId}-${opt.value}`}
            >
              {opt.text}
            </SegmentedControlItem>
          ))}
        </SegmentedControl>
      )}
      {options.length === 0 && <Placeholder />}
    </Base>
  );
}
